module.exports = __webpack_public_path__ + "img/fankui@3x.e039158f.svg";